import { render, staticRenderFns } from "./ComponentAddVehicleViolation.vue?vue&type=template&id=bdaf7808&"
import script from "./ComponentAddVehicleViolation.vue?vue&type=script&lang=ts&"
export * from "./ComponentAddVehicleViolation.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentAddVehicleViolation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VSelect,VTextarea})
